import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { useQuery } from "@tanstack/react-query";

import useFetch, { CacheTime } from "../../../utils/hooks/useFetch.ts";
import { Urls } from "../../urls.ts";

import { BookingResponse } from "./type.ts";

export const useBookingById = () => {
  const { id } = useParams();

  const fetch = useFetch();

  const { data, isLoading, isError, error, refetch } = useQuery<BookingResponse | null, Error, BookingResponse>({
    queryKey: ["booking-id", id],
    enabled: !!id && id !== "new",
    queryFn: () =>
      fetch<BookingResponse>(`${Urls.BookingById}`, {
        method: "GET",
        slug: {
          bookingId: id,
        },
      }),
    refetchInterval: 10000,
    gcTime: CacheTime,
    staleTime: CacheTime,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (isError) {
      toast.error(error?.message || "Error getting booking");
    }
  }, [error?.message, isError]);

  return {
    data,
    isFetching: isLoading,
    refetch
  };
};
